import PrivateRoutList from "./Router/PrivateRoutList";

const DictionayToList = (dict) => {
   const arr = Object.keys(dict).map((key) => ({
      key: key,
      value: dict[key],
   }));
   return arr;
}
const SSNValidator = (val) => {
  var allDigitEqual = ["0000000000", "1111111111", "2222222222", "3333333333", "4444444444", "5555555555", "6666666666", "7777777777", "8888888888", "9999999999"];
  const codeMelliPattern = /^([0-9]{10})+$/;
  if (allDigitEqual.indexOf(val) != -1 || !codeMelliPattern.test(val)) {
    return false;
  }
  var chArray = Array.from(val);
  var num0 = parseInt(chArray[0]) * 10;
  var num2 = parseInt(chArray[1]) * 9;
  var num3 = parseInt(chArray[2]) * 8;
  var num4 = parseInt(chArray[3]) * 7;
  var num5 = parseInt(chArray[4]) * 6;
  var num6 = parseInt(chArray[5]) * 5;
  var num7 = parseInt(chArray[6]) * 4;
  var num8 = parseInt(chArray[7]) * 3;
  var num9 = parseInt(chArray[8]) * 2;
  var a = parseInt(chArray[9]);
  var b = (((((((num0 + num2) + num3) + num4) + num5) + num6) + num7) + num8) + num9;
  var c = b % 11;
  return (((c < 2) && (a == c)) || ((c >= 2) && ((11 - c) == a)));
}
function addMinutesToTime(date, timeStr, minutesToAdd, IsReduce) {
  const [hours, minutes] = timeStr?.split(":").map(Number);
  const newdate = new Date(date);
  if (newdate) {
    newdate.setHours(hours, minutes, 0, 0);
    if (IsReduce === 0)
      newdate.setMinutes(newdate.getMinutes() + minutesToAdd);
    else
      newdate.setMinutes(newdate.getMinutes() - minutesToAdd);
  }
  return newdate
}
 const GetPath = (MenuName,params) => {
        var prout = PrivateRoutList.find(e => e.name === MenuName)
        var path = '';

        if (prout) {
            path = prout.path;
            if (params)
            {var inx=-1;
                params.split('&').map((itm)=>{
                    inx=String(itm).indexOf(':');
                    if(inx>0)
                    {
                        var par=String(itm).substring(0,inx);
                      var amnt=String(itm).substring(inx+1);
                      path=path.replace(':'+par,amnt);
                    }
                });
            }

        }

        return path;

    }

const helper = { DictionayToList, SSNValidator, GetPath }



export default helper;